<app-dialog-header [title]="isEdit ? 'Editar Cupom' : 'Criar Cupom'"></app-dialog-header>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="coupon-form">
      <div class="coupon-form__field">
        <label class="form-label" for="code">Código</label>
        <input
          id="code"
          type="text"
          class="form-control coupon-form__code"
          formControlName="code"
          maxlength="30"
          placeholder="Ex.: VERAO10"
          [class.is-invalid]="controls.code.invalid && controls.code.touched" />
        @if (controls.code.touched && controls.code.hasError("required")) {
          <div class="text-danger">Esse campo é obrigatório.</div>
        }
        @if (controls.code.touched && controls.code.hasError("maxlength")) {
          <div class="text-danger">O código deve ter no máximo 30 caracteres.</div>
        }
        @if (controls.code.touched && controls.code.hasError("pattern")) {
          <div class="text-danger">Use apenas letras e números.</div>
        }
      </div>

      <div class="coupon-form__field">
        <label class="form-label" for="description">Descrição</label>
        <input
          id="description"
          type="text"
          class="form-control"
          formControlName="description"
          placeholder="Descrição interna (opcional)" />
      </div>

      <div class="coupon-form__row">
        <div class="coupon-form__field">
          <label class="form-label" for="discount">Desconto (%)</label>
          <input
            id="discount"
            type="number"
            min="0"
            max="100"
            class="form-control"
            formControlName="discount_percentage"
            placeholder="10"
            [class.is-invalid]="controls.discount_percentage.invalid && controls.discount_percentage.touched" />
          @if (controls.discount_percentage.touched && controls.discount_percentage.invalid) {
            <div class="text-danger">Informe um valor entre 0 e 100. Use 0% para link de comissário sem desconto.</div>
          }
        </div>

        <div class="coupon-form__field">
          <label class="form-label" for="quantity">Quantidade</label>
          <input
            id="quantity"
            type="number"
            min="1"
            class="form-control"
            formControlName="quantity"
            placeholder="50"
            [class.is-invalid]="controls.quantity.invalid && controls.quantity.touched" />
          @if (controls.quantity.touched && controls.quantity.hasError("required")) {
            <div class="text-danger">Esse campo é obrigatório.</div>
          }
          @if (controls.quantity.touched && controls.quantity.hasError("min")) {
            <div class="text-danger">A quantidade não pode ser menor que {{ hasUsage ? coupon?.used_count : 1 }}.</div>
          }
        </div>
      </div>

      <div class="coupon-form__field">
        <label class="form-label" for="expires">Expira em</label>
        <p-datePicker
          inputId="expires"
          formControlName="expires_at"
          [showTime]="true"
          [showIcon]="true"
          [minDate]="minExpiresAt"
          [maxDate]="maxExpiresAt"
          dateFormat="dd/mm/yy"
          hourFormat="24"
          styleClass="w-100"
          appendTo="body" />
        <small class="coupon-form__hint">A validade não pode ultrapassar o fim do evento.</small>
        @if (controls.expires_at.touched && controls.expires_at.invalid) {
          <div class="text-danger">Informe a data de expiração.</div>
        }
      </div>

      <div class="coupon-form__field">
        <label class="form-label" for="max-discounted">Máx. de ingressos com desconto por uso</label>
        <input
          id="max-discounted"
          type="number"
          min="1"
          step="1"
          class="form-control"
          formControlName="max_discounted_items"
          placeholder="1"
          [class.is-invalid]="controls.max_discounted_items.invalid && controls.max_discounted_items.touched" />
        <small class="coupon-form__hint">
          O desconto cobre até esse número de unidades do ingresso-alvo por compra. As demais ficam sem desconto.
        </small>
        @if (controls.max_discounted_items.touched && controls.max_discounted_items.hasError("required")) {
          <div class="text-danger">Esse campo é obrigatório.</div>
        }
        @if (
          controls.max_discounted_items.touched &&
          (controls.max_discounted_items.hasError("min") || controls.max_discounted_items.hasError("integer"))
        ) {
          <div class="text-danger">Informe um número inteiro maior que zero.</div>
        }
      </div>

      <div class="coupon-form__field">
        <label class="form-label" for="tickets">Ingressos / lotes do cupom</label>
        <p-multiselect
          inputId="tickets"
          formControlName="ticket_ids"
          [options]="ticketOptions"
          optionLabel="label"
          optionValue="value"
          [loading]="loadingTickets"
          placeholder="Selecione os ingressos"
          [filter]="true"
          filterPlaceholder="Buscar"
          [showToggleAll]="true"
          display="chip"
          styleClass="w-100"
          appendTo="body" />
        <small class="coupon-form__hint">
          O mesmo código vale para todos os lotes selecionados. O desconto incide sobre o preço do ingresso escolhido na
          compra.
        </small>
        @if (controls.ticket_ids.touched && controls.ticket_ids.invalid) {
          <div class="text-danger">Selecione ao menos um ingresso/lote.</div>
        }
      </div>

      @if (hasUsage) {
        <p class="coupon-form__usage-note">
          Este cupom já possui utilizações: só é possível alterar descrição, quantidade e validade.
        </p>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" [disabled]="loading" (btnClick)="dialogRef.close()">Cancelar</app-button>
  <app-button styleType="primary" [disabled]="loading" (btnClick)="confirm()">
    {{ isEdit ? "Salvar" : "Criar Cupom" }}
  </app-button>
</mat-dialog-actions>

@if (loading) {
  <app-loading />
}
